




















































































































































import IbanAndPDFinput from '@/components/masterData/components/IbanAndPDFinput.vue';
import PaymentandTerms from '@/components/masterData/components/PaymentandTerms.vue';

export default {
    components: {
        'md-iban': IbanAndPDFinput,
        'md-payment': PaymentandTerms,
    },
    props: {
        formObject: Object,
        formstyle: Object,
        nazione: String,
        lists: Object,
        societaUser: Number,
        pdfFile: Object,
    },
    data(this: any): any {
        const checkPECSDI = (rule: any, value: string, callback: any) => {
            if (this.nazione === 'IT' && this.societaUser === 5) {
                if ((this.formObject.SDICode === '' || this.formObject.SDICode == null) && (this.formObject.PECEmail === '' || this.formObject.PECEmail == null)) {
                    callback(new Error(this.$t('masterDataFromRules.SdiPec').toString()));
                }
            }
            callback();
        };
        const checkCredit = (rule : any, value: string, callback: any) => {
            if (Number.isNaN(Number(value))) {
                callback(new Error(this.$t('masterDataFromRules.Number').toString()));
            }
            if (String(value).includes(',')) {
                callback(new Error(this.$t('masterDataFromRules.Number').toString()));
            }
            if (String(value).includes('.')) {
                callback(new Error(this.$t('masterDataFromRules.Number').toString()));
            }
            if (String(value).includes('-')) {
                callback(new Error(this.$t('masterDataFromRules.Number').toString()));
            }
            callback();
        };
        return {
            rules: {
                AdministrativMail: [
                    { required: true, message: this.$t('masterDataFromRules.Required'), trigger: ['blur', 'change'] },
                    { type: 'email', message: this.$t('masterDataFromRules.Email'), trigger: ['blur', 'change'] },
                ],
                InvoiceMail: [
                    { type: 'email', message: this.$t('masterDataFromRules.Email'), trigger: ['blur', 'change'] },
                ],
                PECEmail: [
                    { type: 'email', message: this.$t('masterDataFromRules.Email'), trigger: ['blur', 'change'] },
                    { validator: checkPECSDI, trigger: ['blur', 'change'] },
                ],
                SDICode: [
                    { validator: checkPECSDI, trigger: ['blur', 'change'] },
                    {
                        min: 7, max: 7, message: this.$t('masterDataFromRules.Lenght7'), trigger: ['blur', 'change'],
                    },
                ],
                CreditLimit: [
                    { required: true, message: this.$t('masterDataFromRules.Required') },
                    { validator: checkCredit, trigger: ['blur', 'change'] },
                ],
                Invoicing: [
                    { required: true, message: this.$t('masterDataFromRules.RequiredSelect'), trigger: ['blur', 'change'] },
                ],
                Priority: [
                    { required: true, message: this.$t('masterDataFromRules.RequiredSelect'), trigger: ['blur', 'change'] },
                ],
            },
            validate: false,
            componentValid: {
                iban: false,
                payment: false,
            },
        };
    },
    computed: {
        computeComponentValid(this: any) {
            return (this.componentValid.iban || this.formObject.Payment !== 'RB') && this.componentValid.payment;
        },
    },
    watch: {
        computeComponentValid(this: any, newVal: any, oldVal: any) {
            if (newVal) {
                this.nextStep();
            }
        },
    },
    methods: {
        async ValidateChildren(this: any) {
            this.componentValid.payment = false;
            this.componentValid.iban = false;
            this.validate = !this.validate;
            this.$refs.form.validate();
        },
        async nextStep(this: any) {
            this.$refs.form.validate((val: any) => {
                if (val) {
                    this.$emit('next');
                }
            });
        },
        backStep(this: any, formName: string) {
            this.$refs.form.clearValidate();
            this.$emit('back');
        },
    },
};
